import { render, staticRenderFns } from "./childSpecial.vue?vue&type=template&id=0bce76aa&scoped=true&"
import script from "./childSpecial.vue?vue&type=script&lang=js&"
export * from "./childSpecial.vue?vue&type=script&lang=js&"
import style0 from "./childSpecial.vue?vue&type=style&index=0&id=0bce76aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce76aa",
  null
  
)

export default component.exports